import { TextReveal } from '@virlewood/board-79';
import { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface WelcomeLoadingProps {
  onComplete: () => void;
}

const WelcomeLoading = ({ onComplete }: WelcomeLoadingProps) => {
  useEffect(() => {
    // Minimum 1 second display time
    const timer = setTimeout(onComplete, 1500);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <TextReveal
        variant="fade"
        className="text-3xl font-bold md:text-6xl"
        once={true}
      >
        Benvenuto!
      </TextReveal>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: 0.5 }}
        className="text-muted-foreground text-lg"
      >
        Configuriamo insieme il tuo negozio
      </motion.p>
    </div>
  );
};

export default WelcomeLoading;
